import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';

import useCurrentProjectGroup from 'App/features/project/hooks/useCurrentProjectGroup';
import {
  getOtherQueryParams,
  getProjectHash,
  getRouterProjectHash,
} from 'App/features/project/projectUtils';
import {Project} from 'Pages/project/project_types';

import useProject from '../queries/useProject';

// Use this hook only when you are sure project is loaded
// (basically above ProjectLoader).
const useCurrentProject = (): Project | null => {
  const {search} = useLocation();

  const projectGroup = useCurrentProjectGroup();

  const routerProjectHash = getRouterProjectHash(search);
  const projectHash = getProjectHash(routerProjectHash, projectGroup);

  const otherQueryParams = useMemo(() => getOtherQueryParams(search), [search]);
  return useProject(projectHash, otherQueryParams).data || null;
};

export default useCurrentProject;
